'use client';

export interface ImageAsset {
  mobile?: {
    url: string;
    aspectRatio: number;
  };
  tablet?: {
    url: string;
    aspectRatio: number;
  };
  desktop?: {
    url: string;
    aspectRatio: number
  };
  caption?: string;
}

export interface ImageFigureProps {
  image: ImageAsset;
  alt?: string;
  className?: string;
}

const ImageFigure = ({ image, alt = 'Image', className = '' }: ImageFigureProps) => {
  if (!image.mobile) {
    return null;
  }

  return (
    <figure className={className}>
      <picture>
        {image.desktop && (
          <source media="(min-width: 1024px)" srcSet={image.desktop.url} />
        )}
        {image.tablet && (
          <source media="(min-width: 768px)" srcSet={image.tablet.url} />
        )}
        <img
          src={image.mobile.url}
          alt={alt}
          style={{ width: '100%', height: 'auto' }}
        />
        {image.caption && (
          <figcaption className="caption">
            {image.caption}
          </figcaption>
        )}
      </picture>
    </figure>
  )
};

export default ImageFigure;